import YouTube, { YouTubeProps } from 'react-youtube';

import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from './container';

export type YouTubeVideoSectionProps = {
  title: string;
  video: {
    _id: string;
    youTubeVideoId: string;
    title: string;
  };
  onPlayVideo?: () => void;
};

const videoOptions: YouTubeProps['opts'] = {
  height: '408px',
  width: '100%',
  host: 'https://www.youtube-nocookie.com',
  playerVars: {
    rel: 0,
  },
};

export function YouTubeVideoSection({ title, video, onPlayVideo }: YouTubeVideoSectionProps) {
  return (
    <Box as='section'>
      <ContentContainer>
        <Flex
          alignItems='center'
          justifyContent='center'
          flexDir={{
            base: 'column',
            md: 'row',
          }}
          gap={{
            base: '24px',
            md: '64px',
          }}
        >
          <Box
            flex={{ md: '0 1 544px' }}
            alignSelf={{
              base: 'stretch',
              md: 'unset',
            }}
          >
            <YouTube opts={videoOptions} title={video.title} videoId={video.youTubeVideoId} onPlay={onPlayVideo} />
          </Box>
          <Heading as='h2' flex={{ md: '1 2 512px' }} fontFamily='body' fontWeight='400' size='marketing-3xl'>
            {title}
          </Heading>
        </Flex>
      </ContentContainer>
    </Box>
  );
}
